import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/Auth.css";
import { API_BASE } from "./config";



export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // 👈 loading
  const navigate = useNavigate();
  const [dots, setDots] = useState("");
  

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return; 

    setMsg("");
    setError("");

    if (email.trim().length < 8) {
      setError("Email invalide (minimum 8 caractères)");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setError(data.msg || "Erreur lors de l'envoi du code");
        setLoading(false);
        return;
      }

      // ✅ succès
      setMsg(data.msg || "Code envoyé par email");

      setTimeout(() => {
        navigate("/reset-password", {
          state: { email },
        });
      }, 1500);

    } catch (err) {
      setError("Impossible de contacter le serveur");
    } finally {
      setLoading(false); // 🛑 stop spinner
    }
  };
  useEffect(() => {
    if (!loading) {
      setDots("");
      return;
    }
  
    const interval = setInterval(() => {
      setDots((prev) => (prev.length === 3 ? "" : prev + "."));
    }, 500);
  
    return () => clearInterval(interval);
  }, [loading]);
  

  return (
    <div className="authApp">
      <div className="authCard">
        <h2>Mot de passe oublié</h2>
        <p>Saisissez votre email pour recevoir un code</p>

        {error && <div className="authError">{error}</div>}
        {msg && <div className="authSuccess">{msg}</div>}

        <form onSubmit={submit}>
          <input
            className="authInput"
            type="email"
            placeholder="email@exemple.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />

          <div className="authButtons">
            <button
              className="authBtn authBtnPrimary"
              type="submit"
              disabled={loading}
            >
              {loading ? `En cours${dots}` : "Envoyer le code"}
            </button>
            <button
              className="authBtn authBtnSecondary"
              type="button"
              onClick={() => navigate("/login")}
              disabled={loading}
            >
              Revenir
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
